import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAPage, getPages, resetState } from "../../features/cms/pages/cmsPagesSlice";
import CustomModal from "../../components/CustomModal";
import { delImg } from "../../features/upload/uploadSlice";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "name",
  },
  {
    title: "Published",
    dataIndex: "published",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const PageList = () => {
  const [open, setOpen] = useState(false);
  const [pageId, setPageId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setPageId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getPages());
  }, [dispatch]);
  const getPageState = useSelector((state) => state.cmsPages.pages);
  const data1 = [];
  for (let i = 0; i < getPageState.length; i++) {
    data1.push({
      key: i + 1,
      name: getPageState[i].title,
      published: getPageState[i].isPublished ? "Yes" : "No",
      order: getPageState[i].order || 0,
      action: (
        <>
          <Link
            to={`/admin/cms/page/${getPageState[i]._id || getPageState[i].id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getPageState[i]._id || getPageState[i].id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deletePage = (e) => {
    dispatch(deleteAPage(e));
    dispatch(delImg(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getPages());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Pages List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deletePage(pageId);
        }}
        title="Are you sure you want to delete this page?"
      />
    </div>
  );
};

export default PageList;

